if (!window.Eurus.loadedScript.includes('product-cart.js')) {
  window.Eurus.loadedScript.push('product-cart.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xProductCart', (
        wrappringVariantId,
        engravingVariantId,
      ) => ({
        loading: false,
        errorMessage: false,
        mainHasError: false,
        buttonSubmit: "",
        error_message_wrapper: {},
        stopAction: false,
        insuranceVariantId: '',
        checkSampleLimitBeforeAddToCart(e, required, quickView, sticky) {
          // Prevent the default form submission
          e.preventDefault();
          e.stopPropagation();
          
          // Also prevent immediate propagation
          e.stopImmediatePropagation();
          
          // Check if this is a sample product and quantity exceeds limit
          let productForm = this.$el.closest('.product-info') || this.$el.closest('form');
          if (!productForm) {
            // Fallback: look for the form in the document
            productForm = document.querySelector('form[data-type="add-to-cart-form"]');
          }
          
          if (productForm) {
            // Try multiple selectors to find the quantity input
            let qtyInput = productForm.querySelector('input[name="quantity"]');
            if (!qtyInput) {
              qtyInput = productForm.querySelector('input[id*="Quantity"]');
            }
            if (!qtyInput) {
              qtyInput = productForm.querySelector('input[type="number"]');
            }
            
            if (qtyInput && qtyInput.dataset.limit) {
              const limit = parseInt(qtyInput.dataset.limit);
              const currentQty = parseInt(qtyInput.value);
              
              // Check if selected variant is a sample
              const checkedInputs = productForm.querySelectorAll('input[type="radio"]:checked');
              let isSample = false;
              
              // First check radio inputs (variant options)
              for (let input of checkedInputs) {
                const optionValue = input.value.toLowerCase();
                if (optionValue.includes('single tile') || 
                    optionValue.includes('sample') || 
                    optionValue.includes('single sheet')) {
                  isSample = true;
                  break;
                }
              }
              
              // If no sample detected via radio, check if the product itself is a sample
              if (!isSample) {
                // Check if the product title or handle indicates it's a sample
                const productTitle = document.querySelector('.product-single__title')?.textContent?.toLowerCase() || '';
                const productHandle = window.location.pathname.toLowerCase();
                
                if (productTitle.includes('sample') || 
                    productHandle.includes('sample') ||
                    productTitle.includes('single tile') ||
                    productHandle.includes('single-tile')) {
                  isSample = true;
                }
              }
              
              if (isSample) {
                // Check cart totals before allowing add to cart
                this._checkCartSampleLimit(limit, currentQty, () => {
                  // Cart check passed, proceed with add to cart
                  this.addToCart(e, required, quickView, sticky);
                }, () => {
                  // Cart check failed, show warning and prevent
                  if (window.showSampleLimitWarning) {
                    window.showSampleLimitWarning(limit);
                  } else {
                    setTimeout(() => {
                      if (window.showSampleLimitWarning) {
                        window.showSampleLimitWarning(limit);
                      } else {
                        this._showSampleLimitWarningFallback(limit);
                      }
                    }, 100);
                  }
                  
                  // Reset loading state
                  this.loading = false;
                  
                  // Disable submit button temporarily
                  if (productForm) {
                    const submitBtn = productForm.querySelector('button[type="submit"]');
                    if (submitBtn) {
                      submitBtn.disabled = true;
                      setTimeout(() => {
                        submitBtn.disabled = false;
                      }, 1000);
                    }
                  }
                });
                return; // Don't proceed yet, wait for cart check
              }
            }
          }
          
          // If no sample limit issue, proceed with normal add to cart
          this.addToCart(e, required, quickView, sticky);
        },
        
        _showSampleLimitWarningFallback(limit) {
          // Remove any existing prompts
          const oldPrompts = document.querySelectorAll('.prompt');
          oldPrompts.forEach(prompt => {
            prompt.remove();
          });
          
          // Show warning below the quantity selector on product page
          let quantityContainer = document.querySelector('.quantity-selector-container') ||
                                 document.querySelector('input[id*="Quantity"]')?.closest('.inline-flex') ||
                                 document.querySelector('input[name="quantity"]')?.closest('.inline-flex') ||
                                 document.querySelector('[x-data*="qty:"]') ||
                                 document.querySelector('.quantity-selector');
          
          if (quantityContainer) {
            // Insert warning after the quantity selector
            const warningMessage = `<div class="prompt"><span class="close">&times;</span>Please limit online sample orders to a maximum of ${limit} pieces. For special requests, reach out to us at (856) 988-1802.</div>`;
            
            quantityContainer.insertAdjacentHTML('afterend', warningMessage);
            
            // Add close button functionality
            const closeButton = document.querySelector('.prompt .close');
            if (closeButton) {
              closeButton.addEventListener('click', function() {
                const prompt = this.closest('.prompt');
                if (prompt) {
                  prompt.remove();
                }
              });
            }
          } else {
            // Fallback to product container if quantity selector not found
            let productContainer = document.querySelector('.product-single__meta') || 
                                  document.querySelector('.product-info') || 
                                  document.querySelector('form[data-type="add-to-cart-form"]');
            
            if (productContainer) {
              const warningMessage = `<div class="prompt"><span class="close">&times;</span>Please limit online sample orders to a maximum of ${limit} pieces. For special requests, reach out to us at (856) 988-1802.</div>`;
              
              productContainer.insertAdjacentHTML('afterbegin', warningMessage);
              
              // Add close button functionality
              const closeButton = productContainer.querySelector('.prompt .close');
              if (closeButton) {
                closeButton.addEventListener('click', function() {
                  const prompt = this.closest('.prompt');
                  if (prompt) {
                    prompt.remove();
                  }
                });
              }
            }
          }
        },
        
        // Check cart for existing sample quantities before allowing add to cart
        _checkCartSampleLimit(limit, newQty, onSuccess, onFailure) {
          // Fetch current cart data
          fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
              let totalSampleQty = 0;
              
              // Calculate total quantity of sample products in cart
              cart.items.forEach(item => {
                if (this._isCartItemSample(item)) {
                  totalSampleQty += item.quantity;
                }
              });
              
              // Check if adding new quantity would exceed limit
              if (totalSampleQty + newQty > limit) {
                // Show warning about total cart limit
                onFailure();
              } else {
                onSuccess();
              }
            })
            .catch(error => {
              // If cart fetch fails, proceed with add to cart (fail-safe)
              onSuccess();
            });
        },
        
        // Check if a cart item is a sample product
        _isCartItemSample(cartItem) {
          // Check variant title
          if (cartItem.variant_title) {
            const variantTitle = cartItem.variant_title.toLowerCase();
            if (variantTitle.includes('single tile') || 
                variantTitle.includes('sample') || 
                variantTitle.includes('single sheet')) {
              return true;
            }
          }
          
          // Check product title
          if (cartItem.product_title) {
            const productTitle = cartItem.product_title.toLowerCase();
            if (productTitle.includes('sample') || 
                productTitle.includes('single tile')) {
              return true;
            }
          }
          
          // Check product handle
          if (cartItem.handle) {
            const productHandle = cartItem.handle.toLowerCase();
            if (productHandle.includes('sample') || 
                productHandle.includes('single-tile')) {
              return true;
            }
          }
          
          return false;
        },

        loadInsurance(id) {
          if (this.insuranceVariantId == '') {
            this.insuranceVariantId = id;
          }
        },
        scrollToAtcBtn(btnId) {
          const originalAtcBtn = document.querySelector(`#${btnId}`);
          originalAtcBtn.scrollIntoView({
            behavior: "smooth",
            block: 'center',
            inline: 'center'
          })
        },
        async hashProperties(formData) {
          let result = [];
          for (let [key, value] of formData.entries()) {
            const match = key.match(/^properties\[(.+)\]$/);
            if (match) {
              if (value instanceof File) {
                result.push(`${value.name}:${value.size}:${value.type}`);
              } else {
                result.push(value);
              }
            }
          }
          result.push(formData.get('id'));
          result.sort();

          let data = result.join('|');

          const encoder = new TextEncoder();
          const dataBuffer = encoder.encode(data);

          const hashBuffer = await crypto.subtle.digest('SHA-256', dataBuffer);
          const hashArray = Array.from(new Uint8Array(hashBuffer));
          const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');

          return hashHex;
        },
        async addToCart(e, required, quickView, sticky) {
          this.loading = true;
          e.preventDefault();

          setTimeout(async () => {
            if (required) {
              var productInfo = this.$el.closest('.product-info');
              if(sticky){
                productInfo = document.querySelector('.product-info');
              }
              if (productInfo) {
                var propertiesInput = productInfo.querySelectorAll(`.customization-picker`);
                this.stopAction = false;
                let scrollStatus = false;
                
                propertiesInput.length && propertiesInput.forEach((input) => {
                  if (input.required && input.value.trim() == '' || input.classList.contains("validate-checkbox")) {
                    input.classList.add("required-picker");
                    this.stopAction = true;
                    if(!scrollStatus){
                      input.parentElement.querySelector('.text-required').scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                      });
                      scrollStatus = true;
                    }    
                  }                
                });              
              }
              if (this.stopAction) {
                setTimeout (() => {
                  this.loading = false;
                }, 500);
                return true;
              }
            }

            if (this.$refs.engraving_text && engravingVariantId) {
              if (this.$refs.engraving_text.value.trim()) {
                if (!this.$refs.engraving_text.hasAttribute('name')) this.$refs.engraving_text.setAttribute('name', this.$refs.text_area_name.value);
              } else {
                if (this.$refs.engraving_text.hasAttribute('name')) this.$refs.engraving_text.removeAttribute('name');
              }
            }

            var productForm = this.$el.closest('.product-info') || this.$el.closest('form');
            var edt_element = productForm ? productForm.querySelector('.hidden.cart-edt-properties') : null;
            if (edt_element) {
              edt_element.value = edt_element.value.replace("time_to_cut_off", Alpine.store('xEstimateDelivery').noti)
            }
            let formData = new FormData(this.$refs.product_form);
            
            // Check if calculator is present and use calculated quantity
            const calculatorWrapper = document.querySelector('.calculator-wrapper.active');
            let calculatedQuantity = null;
            if (calculatorWrapper) {
              const finalQuantityInput = calculatorWrapper.querySelector('#finalquantity');
              if (finalQuantityInput && finalQuantityInput.value && parseInt(finalQuantityInput.value) > 0) {
                calculatedQuantity = finalQuantityInput.value;
                // Update the quantity in the form data
                formData.set('quantity', calculatedQuantity);
              }
            }

            if (this.$refs.gift_wrapping_checkbox && this.$refs.gift_wrapping_checkbox.checked && wrappringVariantId && this.$refs.gift_wrapping_id) {              
              await this.hashProperties(formData).then(hashHex => {
                this.$refs.gift_wrapping_id.value = hashHex;
                formData = new FormData(this.$refs.product_form);
              });
            }
            
            // Re-apply calculated quantity after gift wrapping hash (if needed)
            if (calculatedQuantity) {
              formData.set('quantity', calculatedQuantity);
            }

            formData.append(
              'sections',
              Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            const newFormData = new FormData();
            for (let [key, value] of formData.entries()) {
              if (value !== '') {
                newFormData.append(key, value);
              }
            }
            await fetch(`${Eurus.cart_add_url}`, {
              method:'POST',
              headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
              body: newFormData
            }).then(reponse => {
              return reponse.json();
            }).then(async (response) => {
              if (response.status == '422') {
                if (typeof response.errors == 'object') {
                  this.error_message_wrapper = response.errors;
                  document.querySelector('.recipient-error-message').classList.remove('hidden');
                } else {
                  this.errorMessage = true;
                  setTimeout(() => {
                    this.errorMessage = false;
                  }, 3000);
                  if(this.$refs.error_message){
                    this.$refs.error_message.textContent = response.description;
                  }
                  if(this.$refs.error_message_mobile){
                    this.$refs.error_message_mobile.textContent = response.description;
                  }
                }
                if (Alpine.store('xMiniCart')) {
                  Alpine.store('xMiniCart').reLoad();
                }
              } else {  
                if (Alpine.store('xCartNoti') && Alpine.store('xCartNoti').enable) {
                  Alpine.store('xCartNoti').setItem(response); 
                }
                let match = document.cookie.match('(^|;)\\s*' + 'eurus_insurance' + '\\s*=\\s*([^;]+)');
                if (
                  (this.$refs.gift_wrapping_checkbox && this.$refs.gift_wrapping_checkbox.checked && wrappringVariantId) || 
                  (this.$refs.engraving_text && engravingVariantId && this.$refs.engraving_text.value.trim()) || 
                  (this.insuranceVariantId && !localStorage.getItem('insuranceRemoved') && (!match || match[1].trim() === ''))
                ) {
                  let additionalOptionData = {
                    items: [],
                    sections:  Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id)
                  };
                  if (this.$refs.gift_wrapping_checkbox && this.$refs.gift_wrapping_checkbox.checked && wrappringVariantId && response.properties['_gift_wrapping_id']) {
                    additionalOptionData.items.push(
                      {
                        id: wrappringVariantId,
                        quantity: 1,
                        properties: {
                          "For": response.title,
                          "_key_link": response.properties['_gift_wrapping_id']
                        }
                      }
                    );
                  }
                  if (this.$refs.engraving_text && engravingVariantId && this.$refs.engraving_text.value.trim()) {
                    additionalOptionData.items.push(
                      {
                        id: engravingVariantId,
                        quantity: 1
                      }
                    );
                  }
                  if (this.insuranceVariantId && !localStorage.getItem('insuranceRemoved')) {
                    let match = document.cookie.match('(^|;)\\s*' + 'eurus_insurance' + '\\s*=\\s*([^;]+)');
                    if (!match || match[1].trim() === '') {
                      additionalOptionData.items.push(
                        {
                          id: this.insuranceVariantId,
                          quantity: 1
                        }
                      );
                    }
                  }

                  if (additionalOptionData.items.length !== 0) {
                    await window.fetch('/cart/add.js', {
                      method: 'POST',
                      credentials: 'same-origin',
                      headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                      },
                      body: JSON.stringify(additionalOptionData),
                    }).then((response) => {
                      return response.json();
                    }).then(response => {
                      document.querySelector('.recipient-error-message') ? document.querySelector('.recipient-error-message').classList.add('hidden') : '';
                      this.error_message_wrapper = {};
        
                      if (Alpine.store('xQuickView') && Alpine.store('xQuickView').show) {
                        Alpine.store('xQuickView').show = false;
                      }
                      Alpine.store('xPopup').close();
                       
                      if((quickView && Alpine.store('xQuickView').buttonQuickView && Alpine.store('xQuickView').buttonQuickView.dataset.addAsBundle) || (!quickView && this.$refs.product_form && this.$refs.product_form.querySelector('[data-add-as-bundle="true"]'))) {
                        document.dispatchEvent(new CustomEvent("eurus:cart:add-as-bundle"));
                      } else {
                        Alpine.store('xCartHelper').getSectionsToRender().forEach((section => {
                          const sectionElement = document.querySelector(section.selector);
                          if (sectionElement) {
                            if (response.sections[section.id])
                              sectionElement.innerHTML = getSectionInnerHTML(response.sections[section.id], section.selector);
                          }
                        }));
                        if (!Alpine.store('xCartNoti') || !Alpine.store('xCartNoti').enable) {
                          setTimeout(() => {
                            Alpine.store('xMiniCart').openCart();
                          }, 500);
                          document.dispatchEvent(new CustomEvent("eurus:cart:redirect"));  
                        }  
                        Alpine.store('xCartHelper').currentItemCount = parseInt(document.querySelector('#cart-icon-bubble span').innerHTML);
                        document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));

                        // Dispatch box:added event for sealer popup (only for non-excluded products)
                        this.dispatchBoxAddedEvent(response);
                      }
                    });  
                  }
                } else {
                  document.querySelector('.recipient-error-message') ? document.querySelector('.recipient-error-message').classList.add('hidden') : '';
                  this.error_message_wrapper = {};
        
                  if (Alpine.store('xQuickView') && Alpine.store('xQuickView').show) {
                    Alpine.store('xQuickView').show = false;
                  }
                  Alpine.store('xPopup').close();
                  
                  if((quickView && Alpine.store('xQuickView').buttonQuickView && Alpine.store('xQuickView').buttonQuickView.dataset.addAsBundle) || (!quickView && this.$refs.product_form && this.$refs.product_form.querySelector('[data-add-as-bundle="true"]'))) {
                    document.dispatchEvent(new CustomEvent("eurus:cart:add-as-bundle"));
                  } else {
                    Alpine.store('xCartHelper').getSectionsToRender().forEach((section => {
                      const sectionElement = document.querySelector(section.selector);
                      if (sectionElement) {
                        if (response.sections[section.id])
                          sectionElement.innerHTML = getSectionInnerHTML(response.sections[section.id], section.selector);
                      }
                    }));
                    if (!Alpine.store('xCartNoti') || !Alpine.store('xCartNoti').enable) {
                      setTimeout(() => {
                        Alpine.store('xMiniCart').openCart();
                      }, 500);
                    }               
                    Alpine.store('xCartHelper').currentItemCount = parseInt(document.querySelector('#cart-icon-bubble span').innerHTML);
                    document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
                    document.dispatchEvent(new CustomEvent("eurus:cart:redirect"));

                    // Dispatch box:added event for sealer popup (only for non-excluded products)
                    this.dispatchBoxAddedEvent(response);
                  }
                }
              }
            }).catch((error) => {
              console.error('Error:', error);
            }).finally(() => {
              this.loading = false;
              if ((quickView && Alpine.store('xQuickView').buttonQuickView && !Alpine.store('xQuickView').buttonQuickView.dataset.addAsBundle) || (!quickView && this.$refs.product_form && !this.$refs.product_form.querySelector('[data-add-as-bundle="true"]'))) {
                if(this.$refs.gift_wrapping_checkbox) this.$refs.gift_wrapping_checkbox.checked = false;
                if(this.$refs.gift_wrapping_id) this.$refs.gift_wrapping_id.value = '';
              }
              document.cookie = `eurus_insurance=${this.insuranceVariantId}; path=/`;  
            })
          }, 0)
        },
        dispatchBoxAddedEvent(response) {
          // Check if the added product should be excluded from sealer popup
          if (this.isExcludedFromSealerPopup(response)) {
            return; // Don't dispatch event for excluded products
          }
          
          // Dispatch the box:added event after a small delay to ensure DOM updates are complete
          setTimeout(() => {
            document.dispatchEvent(new CustomEvent("box:added", {
              detail: {
                product: response,
                timestamp: Date.now()
              }
            }));
          }, 100);
        },
        isExcludedFromSealerPopup(response) {
          // List of excluded product variants (case-insensitive matching)
          const excludedVariants = [
            'single tile',
            'sample',
            'sample o',
            'sample x',
            'sample (2 pcs)',
            'sample (4 pcs)',
            'single sheet',
            'single sheet (1 sqft)',
            'full sheet 1sqft',
            'sample 8x8'
          ];
          
          // Check variant title
          if (response.variant_title) {
            const variantTitle = response.variant_title.toLowerCase();
            for (const excluded of excludedVariants) {
              if (variantTitle.includes(excluded)) {
                return true;
              }
            }
          }
          
          // Check product title
          if (response.title || response.product_title) {
            const productTitle = (response.title || response.product_title).toLowerCase();
            for (const excluded of excludedVariants) {
              if (productTitle.includes(excluded)) {
                return true;
              }
            }
          }
          
          return false;
        }
      }))
    });
  });
}
